<template>
  <div class="d-flex align-items-center goal-row mb-1 overflow-hidden">
    <project-icon class="flex-shrink-0" :color="option.color" />
    <span class="text-truncate ml-2" :title="option.label" v-no-capture>{{ option.label }}</span>
  </div>
</template>

<script>
import ProjectIcon from '@/components/project/ProjectIcon.vue'

/**
 * This provides the template for the individual items in Project filter dropdown
 */
export default {
  name: 'ProjectListItemTemplate',
  components: { ProjectIcon },
  props: ['option'],
  computed: {}
}
</script>
<style lang="scss" scoped></style>
